// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import dataTableStyles from "@conklin/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { productPriceStyles } from "@conklin/Overrides/Components/ProductPrice";
import { quickOrderProductListStyles } from "@conklin/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { color, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

quickOrderProductListStyles.wrapper = {
    css: css`
        padding-bottom: 0;
    `,
};

quickOrderProductListStyles.container = {
    css: css`
        padding-top: 16px;
        margin-top: 16px;
        border-top: 1px solid ${color("common.border")};
    `,
};

quickOrderProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

quickOrderProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

quickOrderProductListStyles.productNumber = {
    ...cartLineSharedStyles.productPartNumbers,
};

quickOrderProductListStyles.availability = {
    ...cartLineSharedStyles.productAvailability,
};

quickOrderProductListStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

quickOrderProductListStyles.priceTotal = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
quickOrderProductListStyles.priceInvalid = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        text: {
            ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text,
        },
    },
};

quickOrderProductListStyles.removeProductIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

quickOrderProductListStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};

quickOrderProductListStyles.noProductListWrapper = {
    css: css`
        width: 100%;
        text-align: center;
        padding-top: 16px;
        margin-top: 16px;
        border-top: 1px solid ${color("common.border")};
    `,
};

quickOrderProductListStyles.noProductListText = {
    ...mergeWithCss(dataTableStyles.noResultsText, {
        css: css`
            max-width: 100%;
        `,
    }),
};

quickOrderProductListStyles.infoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 8px;
    `,
};
quickOrderProductListStyles.cartLineContainer = {
    total: {
        css: css`
            text-align: right;
            ${xScreen("lte", "md")} {
                text-align: left;
                grid-column: 4 / 7;
            }
        `,
    },
};
